/* Mēllo forms: friendly inline validation, first-name thank-you, smooth scroll to a form. */
(() => {
  if (window.MelloForms) return;
  window.MelloForms = true;

  const EMAIL = /^\S+@\S+\.\S+$/;
  const NAME_KEY = 'mello:first-name';
  const reduced = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const fieldBad = (input) => {
    const v = input.value.trim();
    if (input.type === 'email') return !EMAIL.test(v);
    return input.required && !v;
  };

  const validate = (form) => {
    let first = null;
    form.querySelectorAll('[data-field]').forEach((field) => {
      const input = field.querySelector('input, textarea');
      if (!input) return;
      const bad = fieldBad(input);
      const msg = field.querySelector('[data-error]');
      field.classList.toggle('is-error', bad);
      if (bad) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
      if (msg) msg.hidden = !bad;
      if (bad && !first) first = input;
    });
    return first;
  };

  const init = (scope = document) => {
    scope.querySelectorAll('form[data-validate]').forEach((form) => {
      if (form.dataset.validateReady) return;
      form.dataset.validateReady = '1';
      form.setAttribute('novalidate', '');
      let tried = false;
      form.addEventListener('submit', (e) => {
        tried = true;
        const bad = validate(form);
        if (bad) {
          e.preventDefault();
          bad.focus();
          return;
        }
        const nameInput = form.querySelector('[data-first-name-source]');
        if (nameInput) {
          try { sessionStorage.setItem(NAME_KEY, nameInput.value.trim().split(/\s+/)[0] || ''); } catch (err) { /* storage blocked */ }
        }
        const btn = form.querySelector('[type="submit"]');
        if (btn) btn.setAttribute('aria-busy', 'true');
      });
      form.addEventListener('input', () => { if (tried) validate(form); });
    });

    scope.querySelectorAll('[data-first-name]').forEach((el) => {
      try {
        const n = sessionStorage.getItem(NAME_KEY);
        if (n) el.textContent = n;
      } catch (err) { /* storage blocked */ }
    });
  };

  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[data-scroll-to]');
    if (!link) return;
    const id = (link.getAttribute('href') || '').split('#')[1];
    const target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
    if (window.history && history.replaceState) history.replaceState(null, '', `#${id}`);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
